<template>
  <div class="share-container">
    <!-- 顶部分享提示 -->
    <div class="share-header">
      <svg class="success-icon" width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- 背景光圈 -->
        <circle class="bg-circle" cx="100" cy="100" r="90" fill="#F6FFED" />
        <circle class="pulse-circle" cx="100" cy="100" r="70" fill="#D9F7BE" fill-opacity="0.5" />
        
        <!-- 成功标记 -->
        <g class="check-group">
          <circle cx="100" cy="100" r="50" fill="#52C41A" />
          <path class="check" 
            d="M85 100L95 110L115 90" 
            stroke="white" 
            stroke-width="8" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
        </g>
        
        <!-- 装饰星星 -->
        <g class="stars">
          <circle class="star" cx="50" cy="50" r="4" fill="#52C41A" />
          <circle class="star" cx="150" cy="50" r="4" fill="#52C41A" />
          <circle class="star" cx="50" cy="150" r="4" fill="#52C41A" />
          <circle class="star" cx="150" cy="150" r="4" fill="#52C41A" />
        </g>
        
        <!-- 装饰线条 -->
        <g class="lines" stroke="#B7EB8F" stroke-width="2">
          <line class="line" x1="30" y1="100" x2="45" y2="100" />
          <line class="line" x1="155" y1="100" x2="170" y2="100" />
          <line class="line" x1="100" y1="30" x2="100" y2="45" />
          <line class="line" x1="100" y1="155" x2="100" y2="170" />
        </g>
      </svg>
      
      <h2 class="share-title">创建成功，快去分享作品吧！</h2>
    </div>

    <!-- 操作按钮 -->
    <div class="action-buttons">
      <router-link
          class="content-card"
          :to="'/home/creation/detail/'+$route.query.id "
      >
      <el-button type="primary" class="action-btn">
        查看作品
      </el-button> </router-link>
      <el-button type="primary" class="action-btn pro">
        原创保护 <span class="pro-tag">PRO</span>
      </el-button>
    </div>

    <!-- 分享链接 -->
    <div class="share-link-box">
      <div class="link-section">
        <el-input
          v-model="shareLink"
          readonly
          class="link-input"
          size="small"
        >
          <template #append>
            <el-button @click="copyLink" size="small">复制链接</el-button>
          </template>
        </el-input>
      </div>
      
      <!-- 二维码部分 -->
      <div class="qrcode-section">
        <div class="qrcode-wrapper" ref="qrcodeRef"></div>
        <el-button 
          size="small" 
          type="primary" 
          plain 
          @click="downloadQRCode"
          class="download-btn"
        >
          <i class="el-icon-download"></i> 保存二维码
        </el-button>
      </div>
    </div>

    <!-- 社交分享 -->
    <div class="social-share">
      <h3 class="share-subtitle">分享到社交平台</h3>
      <div class="social-buttons">
        <!-- 微信 -->
        <div class="social-btn wechat" @click="shareToWechat">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M8.5,13.5A1.5,1.5 0 0,1 7,12A1.5,1.5 0 0,1 8.5,10.5A1.5,1.5 0 0,1 10,12A1.5,1.5 0 0,1 8.5,13.5M15.5,13.5A1.5,1.5 0 0,1 14,12A1.5,1.5 0 0,1 15.5,10.5A1.5,1.5 0 0,1 17,12A1.5,1.5 0 0,1 15.5,13.5M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20" fill="#07C160"/>
          </svg>
          <span>微信</span>
        </div>

        <!-- 微博 -->
        <div class="social-btn weibo" @click="shareToWeibo">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M9.82727273,12.4018182 C8.85454545,12.4018182 8.07272727,13.1836364 8.07272727,14.1563636 C8.07272727,15.1290909 8.85454545,15.9109091 9.82727273,15.9109091 C10.8,15.9109091 11.5818182,15.1290909 11.5818182,14.1563636 C11.5818182,13.1836364 10.8,12.4018182 9.82727273,12.4018182 Z M15.8181818,12.4018182 C14.8454545,12.4018182 14.0636364,13.1836364 14.0636364,14.1563636 C14.0636364,15.1290909 14.8454545,15.9109091 15.8181818,15.9109091 C16.7909091,15.9109091 17.5727273,15.1290909 17.5727273,14.1563636 C17.5727273,13.1836364 16.7909091,12.4018182 15.8181818,12.4018182 Z" fill="#FF8200"/>
          </svg>
          <span>微博</span>
        </div>

        <!-- 抖音 -->
        <div class="social-btn douyin" @click="shareToDouyin">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M16.6,5.82 C15.9,4.87 15.5,3.71 15.5,2.5 L12.5,2.5 L12.5,15.5 C12.5,16.88 11.38,18 10,18 C8.62,18 7.5,16.88 7.5,15.5 C7.5,14.12 8.62,13 10,13 C10.57,13 11.1,13.17 11.55,13.45 L11.55,10.3 C11.05,10.13 10.53,10.05 10,10.05 C7,10.05 4.5,12.54 4.5,15.55 C4.5,18.56 7,21.05 10,21.05 C13,21.05 15.5,18.56 15.5,15.55 L15.5,9.23 C16.44,9.89 17.54,10.3 18.7,10.3 L18.7,7.3 C17.85,7.3 17.06,6.93 16.6,5.82 Z" fill="#000000"/>
          </svg>
          <span>抖音</span>
        </div>

        <!-- 小红书 -->
        <div class="social-btn xiaohongshu" @click="shareToXiaohongshu">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M12,4 C7.58,4 4,7.58 4,12 C4,16.42 7.58,20 12,20 C16.42,20 20,16.42 20,12 C20,7.58 16.42,4 12,4 Z" fill="#FE2C55"/>
            <path d="M8,8 L16,8 L16,10 L8,10 L8,8 Z M8,11 L16,11 L16,13 L8,13 L8,11 Z M8,14 L13,14 L13,16 L8,16 L8,14 Z" fill="#FE2C55"/>
          </svg>
          <span>小红书</span>
        </div>
      </div>
    </div>

    <!-- 设置面板 -->
    <div class="settings-panel">
      <div class="settings-flex">
        <!-- 出售设置 -->
<!--        <div class="settings-section">
          <div class="section-header">
            <h3 class="section-title">出售设置</h3>
          </div>
          <div class="section-content">
            <div class="setting-item">
              <span class="setting-label">
                仅在全家桶中销售
                <el-tooltip content="在全家桶中进行销售" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-switch v-model="settings.familyOnly"></el-switch>
            </div>
            <div class="setting-item">
              <span class="setting-label">限量销售</span>
              <el-switch
                v-model="settings.limitedSale"
                active-text="Y"
                inactive-text="N"
                active-value="Y"
                inactive-value="N"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </div>
            <div class="setting-item">
              <span class="setting-label">限时优惠</span>
              <el-button type="text" class="setting-action">去设置</el-button>
            </div>
            <div class="setting-item">
              <span class="setting-label">优惠码</span>
              <el-button type="text" class="setting-action">去设置</el-button>
            </div>
          </div>
        </div>-->

        <!-- 作品展示 -->
        <div class="settings-section">
          <div class="section-header">
            <h3 class="section-title">作品展示</h3>
          </div>
          <div class="section-content">
            <div class="setting-item">
              <span class="setting-label">
                展示创作时间
                <el-tooltip content="在作品页面显示创作时间" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-switch
                  @change="submitForm"
                  active-value="Y"
                  inactive-value="N"
                  v-model="settings.showTime"></el-switch>
            </div>
            <div class="setting-item">
              <span class="setting-label">公开
                 <el-tooltip content="可被搜索到" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip></span>
              <el-switch
                  @change="submitForm"
                  active-value="Y"
                  inactive-value="N"
                  v-model="settings.isOpen"></el-switch>
            </div>
          </div>
        </div>

        <!-- 个性设置 -->
        <div class="settings-section">
          <div class="section-header">
            <h3 class="section-title">个性设置</h3>
          </div>
          <div class="section-content">
            <div class="setting-item">
              <span class="setting-label">
                作品标签
                <el-tooltip content="添加标签以便更好地被发现" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <div class="tags-wrapper">
                <el-tag
                  v-for="tag in tags"
                  :key="tag"
                  closable
                  @close="handleClose(tag)"
                >
                  {{ tag }}
                </el-tag>
                
                <!-- 标签输入框 -->
                <el-input
                  v-if="inputVisible"
                  ref="tagInput"
                  v-model="inputValue"
                  size="small"
                  class="tag-input"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                
                <!-- 添加标签按钮 -->
                <el-button 
                  v-else 
                  size="small" 
                  @click="showTagInput"
                  class="button-new-tag"
                >
                  + 添加标签
                </el-button>
              </div>
            </div>
<!--            <div class="setting-item">
              <span class="setting-label">
                仅购买者可以评论
                <el-tooltip content="只有购买后才能发表评论" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-switch v-model="settings.buyerCommentOnly"></el-switch>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'ShareSettings',
  data() {
    return {
      shareLink: '',
      qrLink: '',
      settings: {
        showTime:"Y",
        isOpen: "Y",
        antiTheft: "N", //开启水印
        onlyPurchaser: "N",	//仅购买者可以评论
        openData: "Y", //公开销售数据
        limitedSales:'N',  //开启限量销售
        limite: 20,
      },
      tags: ['标签'],
      inputVisible: false,
      inputValue: '',
      qrcode: null
    }
  },
  mounted() {
    this.shareLink= process.env.VUE_APP_SHARE_BASE+'/#/creation/'+this.$route.query.id
    this.qrLink=process.env.VUE_APP_SHARE_BASE+`/h5/#/pages/creation/detail?id=${this.$route.query.id}`
    this.$nextTick(() => {
      this.generateQRCode()
    })
    this.$http2({
      url: `/preview/${this.$route.query.id}`,
      method: 'get'
    }).then((res) => {
      this.updateSettings(res.data)
     this.tags= res.data.tags ? res.data.tags.split(',') : []
    })
  },
  methods: {
    // 只对已有属性赋值的方法
    updateSettings(responseData) {
      Object.keys(this.settings).forEach(key => {
        // 方式1：使用 Object.prototype.hasOwnProperty.call()
        if (Object.prototype.hasOwnProperty.call(responseData, key)) {
          this.settings[key] = responseData[key]
        }
      })
    },
    copyLink() {
      navigator.clipboard.writeText(this.shareLink).then(() => {
        this.$message.success('链接已复制')
      }).catch(() => {
        this.$message.error('复制失败，请手动复制')
      })
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
      this.submitForm()
    },
    showTagInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.tagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue.trim();
      if (inputValue) {
        if (!this.tags.includes(inputValue)) {
          this.tags.push(inputValue);
        } else {
          this.$message.warning('标签已存在');
        }
      }
      this.inputVisible = false;
      this.inputValue = '';
      this.submitForm()
    },
    shareToWechat() {
      // 生成微信分享二维码
      this.$message.success('请用微信扫描二维码分享');
    },
    shareToWeibo() {
      const shareUrl = encodeURIComponent(window.location.href);
      const title = encodeURIComponent('我的新作品');
      window.open(`http://service.weibo.com/share/share.php?url=${shareUrl}&title=${title}`);
    },
    shareToDouyin() {
      this.$message.info('复制链接去抖音分享');
      // 实现抖音分享逻辑
    },
    shareToXiaohongshu() {
      this.$message.info('复制链接去小红书分享');
      // 实现小红书分享逻辑
    },
    // 生成二维码
    generateQRCode() {
      if (this.qrcode) {
        this.qrcode.clear()
      }
      this.qrcode = new QRCode(this.$refs.qrcodeRef, {
        text: this.qrLink,
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    
    // 下载二维码
    downloadQRCode() {
      const canvas = this.$refs.qrcodeRef.querySelector('canvas')
      if (canvas) {
        const url = canvas.toDataURL('image/png')
        const a = document.createElement('a')
        a.download = '分享二维码.png'
        a.href = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },
    submitForm() {
      // 示例转换
      const formData = {
        ...this.settings,
        id: this.$route.query.id,
        tags:this.tags.join(",")
      }
      // ... 其他提交逻辑
      this.$http2({
        url: `/klgeek/creation/update`,
        method: 'put',
        data:formData
      }).then((res) => {
        this.$message({
          message: '更新成功',
          type: 'success'
        });
      })
    }
  },
  watch: {
    shareLink: {
      handler(newVal) {
        this.$nextTick(() => {
          this.generateQRCode()
        })
      }
    }
  }
}
</script>

<style scoped>
.share-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
}

.share-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.success-icon {
  margin-bottom: 24px;
}

.share-title {
  font-size: 24px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

/* 动画效果 */
.bg-circle {
  animation: pulse 2s ease-in-out infinite;
}

.pulse-circle {
  animation: pulse 2s ease-in-out infinite 0.5s;
}

.check {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  animation: draw 1s ease forwards;
}

.star {
  animation: twinkle 1.5s ease-in-out infinite alternate;
}

.line {
  animation: stretch 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes twinkle {
  from {
    opacity: 0.4;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes stretch {
  0%, 100% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(1.2);
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
}

.action-btn {
  padding: 12px 24px;
  font-size: 16px;
}

.action-btn.pro {
  background: linear-gradient(45deg, #FF6B00, #FF9500);
}

.pro-tag {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 8px;
}

.share-link-box {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin: 20px 0;
  display: flex;
  gap: 16px;
  align-items: center;
}

.link-section {
  flex: 1;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.qrcode-wrapper {
  padding: 4px;
  background: white;
  border-radius: 4px;
}

/* 修改二维码生成大小 */
:deep(.qrcode-wrapper img),
:deep(.qrcode-wrapper canvas) {
  width: 100px !important;
  height: 100px !important;
}

.download-btn {
  padding: 6px 12px;
  font-size: 12px;
}

.social-share {
  margin: 30px 0;
  text-align: center;
}

.share-subtitle {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

.social-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.social-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f5f5f5;
  min-width: 100px;
}

.social-btn span {
  font-size: 14px;
  color: #666;
}

/* 各平台特定样式 */
.social-btn.wechat:hover {
  background: #f0fff0;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.1);
}

.social-btn.weibo:hover {
  background: #fff5f0;
  box-shadow: 0 4px 12px rgba(255, 130, 0, 0.1);
}

.social-btn.douyin:hover {
  background: #f5f5f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.social-btn.xiaohongshu:hover {
  background: #fff0f5;
  box-shadow: 0 4px 12px rgba(254, 44, 85, 0.1);
}

/* 动画效果 */
.social-btn:hover {
  transform: translateY(-2px);
}

.social-btn:active {
  transform: translateY(0);
}

.settings-panel {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.settings-flex {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.settings-section {
  flex: 1;
  min-width: 300px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease;
}

.settings-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #EBEEF5;
}

.section-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.setting-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
}

.setting-action {
  color: #FF6B00;
  padding: 0;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.tag-input {
  width: 100px;
  margin-right: 8px;
  vertical-align: bottom;
}

.button-new-tag {
  font-size: 12px;
  padding: 0 8px;
  height: 32px;
  border-radius: 4px;
}

/* 标签样式美化 */
:deep(.el-tag) {
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  padding: 0 8px;
  height: 32px;
  line-height: 30px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
}

:deep(.el-tag .el-icon-close) {
  color: #909399;
  font-weight: bold;
}

:deep(.el-tag .el-icon-close:hover) {
  background-color: #909399;
  color: #fff;
}

/* 输入框样式 */
:deep(.el-input__inner) {
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .settings-flex {
    flex-direction: column;
  }
  
  .settings-section {
    padding: 16px;
  }
  
  .setting-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .tag-input {
    width: 100%;
    margin-right: 0;
  }
  
  .button-new-tag {
    width: 100%;
    margin-top: 8px;
  }
  
  .success-icon {
    width: 150px;
    height: 150px;
  }
  
  .share-title {
    font-size: 20px;
  }
  
  .share-link-box {
    flex-direction: column;
    padding: 12px;
  }
  
  .qrcode-section {
    width: 100%;
    padding: 8px;
  }
}

/* 优化 switch 样式 */
:deep(.el-switch__label) {
  color: #fff;
  font-weight: bold;
}

:deep(.el-switch__label.is-active) {
  color: #fff;
}

:deep(.el-switch__label--left) {
  position: relative;
  left: 6px;
}

:deep(.el-switch__label--right) {
  position: relative;
  right: 6px;
}

:deep(.el-switch.is-checked .el-switch__core) {
  border-color: #13ce66;
  background-color: #13ce66;
}

</style>